import React from 'react'
import './education.css'

const Education = () => {
  return (
    <section class="timeline-section">
      <h5>timeline of education</h5>
      <h2>Education</h2>
	<div class="timeline-items">
		<div class="timeline-item">
			<div class="timeline-dot"></div>
			<div class="timeline-date">DEC 2022- JULY 2024 (LE)</div>
			<div class="timeline-content">
				<h3>Bachelor of Technology</h3>
				<p>I'm pursuing a <b>Bachelor of Technology</b> in <b>Computer Science</b> Branch from <b>ABES Institute of Technology</b>, Ghaziabad affiliated with <b>Dr. APJ Abdul Kalam University</b>, Lucknow, UP, India. </p>
			</div>
		</div>
		<div class="timeline-item">
			<div class="timeline-dot"></div>
			<div class="timeline-date">2020</div>
			<div class="timeline-content">
				<h3>Diploma</h3>
				<p>Pursued <b>Diploma</b> from <b>GB Pant Institute of Technology, Delhi</b> in <b>Electrical Engineering</b> and <b></b>  secured <b>74.4 percent</b> in it. </p>
			</div>
		</div>
		<div class="timeline-item">
			<div class="timeline-dot"></div>
			<div class="timeline-date">2017</div>
			<div class="timeline-content">
				<h3>High School</h3>
				<p>Pursued <b>High School</b> from <b>Divine Public School, Delhi</b> <b></b> and <b></b>  secured <b>88.6 percent</b> in it. </p>
			</div>
		</div>
	</div>
</section>

  )
}

export default Education
